import React from 'react';
import {
    Accordion,
    // , Highlight
    Highlight,
} from '@mantine/core';

import Divisions from './Divisions';
import OpsLeaderCard from './OpsLeaderCard';
import { OpsAreaHierarchy } from '../../codegen/graphql';
import { useOrganisationSearch } from '../../context/OrganisationSearchContext';

type Props = Readonly<{
    opsArea: OpsAreaHierarchy;
}>;

function OpsAreaCard({ opsArea }: Props) {
    const { organisationSearch } = useOrganisationSearch();

    return (
        <Accordion.Item
            value={opsArea.id ?? ''}
            className="mb-3 border-4 border-red-600 "
        >
            <Accordion.Control
                style={{ borderLeft: '4px solid #00539F' }}
                className="h-10 border-l-4 border-[#00539F] hover:bg-primary-light/50"
            >
                <Highlight
                    fw="bold"
                    tt="capitalize"
                    size="md"
                    highlight={organisationSearch}
                    className="hover:bg-primary-light/50"
                >
                    {opsArea.name ?? ''}
                </Highlight>
            </Accordion.Control>
            <Accordion.Panel className="p-0">
                {opsArea && (
                    <OpsLeaderCard
                        personsRole="executive"
                        person={opsArea?.executive}
                    />
                )}

                {opsArea.divisions && opsArea.divisions.length ? (
                    <Divisions divisions={opsArea.divisions} />
                ) : (
                    <div className="flex items-center justify-center h-20">
                        <p className="font-medium">No Divisions Found</p>
                    </div>
                )}
            </Accordion.Panel>
        </Accordion.Item>
    );
}

export default OpsAreaCard;
